import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";
import fileDownload from "js-file-download";

const getAllVoucher = async (params: any) => {
  const url = endpoints.VOUCHER;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });

  return response;
};

const getVoucherById = async (id: any) => {
  const url = endpoints.VOUCHER + `/${id}`;
  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response;
};

const getVoucherByCode = async (params: any) => {
  const url = endpoints.VOUCHER + `/check`;
  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params
  });
  return response;
};

const createVoucher = async (params: any) => {
  const url = endpoints.VOUCHER;

  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const updateVoucher = async (params: any) => {
  const url = endpoints.VOUCHER + `/${params.id}`;
  const { data: response } = await axios.patch(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response;
};

const deleteVoucher = async (id: any) => {
  const url = endpoints.VOUCHER + `/${id}`;

  const { data: response } = await axios.delete(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const downloadTemplate = async () => {
  const url = endpoints.VOUCHER_TEMPLATE_DOWNLOAD;
  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
      ContentType:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    responseType: "arraybuffer",
  });

  const blob = new Blob([response], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  fileDownload(blob, `voucher_template.xlsx`);
  return blob;
};

const uploadExcel = async (formData: FormData) => {
  const url = endpoints.VOUCHER_UPLOAD;
  const { data: response } = await axios.post(url, formData, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response;
};

const getVoucherStatistics = async (params?: any) => {
  const url = endpoints.VOUCHER_STATISTICS;
  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });
  return response;
};

const downloadReport = async (params?: any) => {
  const url = endpoints.VOUCHER_REPORT_DOWNLOAD;
  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
      ContentType:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    responseType: "arraybuffer",
    params,
  });

  const blob = new Blob([response], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const filename = params?.event_id 
    ? `voucher_usage_report_${params.event_id}_${new Date().toISOString().split('T')[0]}.xlsx`
    : `voucher_usage_report_${new Date().toISOString().split('T')[0]}.xlsx`;
  
  fileDownload(blob, filename);
  return blob;
};

const voucherService = {
  createVoucher,
  deleteVoucher,
  updateVoucher,
  getAllVoucher,
  getVoucherById,
  getVoucherByCode,
  downloadTemplate,
  uploadExcel,
  getVoucherStatistics,
  downloadReport,
};

export default voucherService;
